import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import {AuthService} from './auth.service';
import {Role} from './user';

@Directive({
    selector: '[zahRequiresOneOfRoles]',
    standalone: false
})
export class RequiresOneOfRolesDirective {
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private authService = inject(AuthService);

  private visible = false;

  @Input()
  set zahRequiresOneOfRoles(roles: Array<Role>) {
    this.authService.getUser$().subscribe(user => {
      if (!user.hasOneOfRoles(roles)) {
        this.visible = false;
        this.viewContainerRef.clear();
      } else if (!this.visible) {
        this.visible = true;
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }
}
